import { Box, Button, Grid, TextField, Typography, } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoneIcon from '@mui/icons-material/Done';
import "./NewConnectionForm.scss";
import { cfpBaseUrl } from '../../../network/urls';
import { useLocation } from 'react-router';
import { handleFileUpload } from '../../../services/Functions';
import { CircularProgress, Backdrop } from '@mui/material';
import Error from '../../../components/error/error';
import { useSelector } from 'react-redux';
import { documentExtensions } from '../../../utils/PortalName';

const Newconnectionupdatedocuments = () => {

    const initialValues = {
        // Required Documents Initial Values
        iv_applicant_cnic_document_front: null,
        iv_applicant_cnic_document_back: null,
        iv_property_documents: null,
        iv_near_by_bill: null,
        iv_any_other_document: null,
        iv_owner_cnic_document_front: null,
        iv_owner_cnic_document_back: null,
        iv_noc_owner: null,
        iv_resolution: null,
        iv_memo: null,
        iv_form29initial: null,
    }

    // Documents states
    const [applicantCnicDocumentFront, setApplicantCnicDocumentFront] = useState('');
    const [applicantCnicDocumentBack, setApplicantCnicDocumentBack] = useState('');
    const [propertyDocuments, setPropertDocuments] = useState('');
    const [nearByBillDocument, setNearByBillDocument] = useState('');
    const [anyOtherDocument, setAnyOtherDocument] = useState('');
    const [nocOwnerDocument, setNocOwnerDocument] = useState('');
    const [ownerCnicDocumentFront, setOwnerCnicDocumentFront] = useState('');
    const [ownerCnicDocumentBack, setOwnerCnicDocumentBack] = useState('');
    const [resolutionDocument, setResolutionDocument] = useState('');
    const [memorandumDocument, setMemorandumDocument] = useState('');
    const [form29Document, setForm29Document] = useState('');
    // Thumbnail states
    const [applicantCnicDocumentFrontThumbnail, setApplicantCnicDocumentFrontThumbnail] = useState('');
    const [applicantCnicDocumentBackThumbnail, setApplicantCnicDocumentBackThumbnail] = useState('');
    const [propertyDocumentsThumbnail, setPropertyDocumentsThumbnail] = useState('');
    const [nearByBillDocumentThumbnail, setNearByBillDocumentThumbnail] = useState('');
    const [anyOtherDocumentThumbnail, setAnyOtherDocumentThumbnail] = useState('');
    const [nocOwnerDocumentThumbnail, setNocOwnerDocumentThumbnail] = useState('');
    const [ownerCnicDocumentFrontThumbnail, setOwnerCnicDocumentFrontThumbnail] = useState('');
    const [ownerCnicDocumentBackThumbnail, setOwnerCnicDocumentBackThumbnail] = useState('');
    const [resolutionDocumentThumbnail, setResolutionDocumentThumbnail] = useState('');
    const [memorandumDocumentThumbnail, setMemorandumDocumentThumbnail] = useState('');
    const [form29DocumentThumbnail, setForm29DocumentThumbnail] = useState('')

    const [applicantCnicFrontError, setApplicantCnicFrontError] = useState('')
    const [applicantCnicBackError, setApplicantCnicBackError] = useState('')
    const [propertyDocumentError, setPropertyDocumentError] = useState('')
    const [nearByBillError, setNearByBillError] = useState('')
    const [anyOtherDocumentError, setAnyOtherDocumentError] = useState('');
    const [referenceNumberError, setReferenceNumberError] = useState('')
    const [bodError, setBodError] = useState('')
    const [memorandumError, setMemorandumError] = useState('')
    const [formError, setFormError] = useState('')
    const [ownerCnicFrontError, setOwnerCnicFrontError] = useState('')
    const [ownerCnicBackError, setOwnerCnicBackError] = useState('')
    const [nocError, setNocError] = useState('')

    const [connectionType, setConnectionType] = useState()
    const [applicantStatus, setApplicantStatus] = useState()
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const { state } = useLocation();
    const { dialogRowData } = state;
    const [dialogRowDataLocal, setDialogRowDataLocal] = useState();
    let { token, userId } = useSelector((state) => state.auth)
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (dialogRowData) {
            let dialogData = dialogRowData
            setDialogRowDataLocal(dialogData)
        }
    }, [dialogRowData])

    useEffect(() => {
        if (dialogRowData) {
            setConnectionType(dialogRowData.connectionType)
            setApplicantStatus(dialogRowData.applicantStatus)
        }
        if (dialogRowData.copyOfApplicantCNICFront) {
            values.iv_applicant_cnic_document_front = dialogRowData.copyOfApplicantCNICFront
            setApplicantCnicDocumentFrontThumbnail(dialogRowData.copyOfApplicantCNICFront)
        }
        if (dialogRowData.copyOfApplicantCNICBack) {
            values.iv_applicant_cnic_document_back = dialogRowData.copyOfApplicantCNICBack
            setApplicantCnicDocumentBackThumbnail(dialogRowData.copyOfApplicantCNICBack)
        }
        if (dialogRowData.premisesDocument) {
            values.iv_property_documents = dialogRowData.premisesDocument
            setPropertyDocumentsThumbnail(dialogRowData.premisesDocument)
        }
        if (dialogRowData.scannedCopyOfNearByElectricityBill) {
            values.iv_near_by_bill = dialogRowData.scannedCopyOfNearByElectricityBill
            setNearByBillDocumentThumbnail(dialogRowData.scannedCopyOfNearByElectricityBill)
        }
        if (dialogRowData.anyOtherDocument) {
            values.iv_any_other_document = dialogRowData.anyOtherDocument
            setAnyOtherDocumentThumbnail(dialogRowData.anyOtherDocument)
        }
        if (dialogRowData.copyOfOwnerCNICFront) {
            values.iv_owner_cnic_document_front = dialogRowData.copyOfOwnerCNICFront
            setOwnerCnicDocumentFrontThumbnail(dialogRowData.copyOfOwnerCNICFront)
        }
        if (dialogRowData.copyOfOwnerCNICBack) {
            values.iv_owner_cnic_document_back = dialogRowData.copyOfOwnerCNICBack
            setOwnerCnicDocumentBackThumbnail(dialogRowData.copyOfOwnerCNICBack)
        }
        if (dialogRowData.ownerNOC) {
            values.iv_noc_owner = dialogRowData.ownerNOC
            setNocOwnerDocumentThumbnail(dialogRowData.ownerNOC)
        }
        if (dialogRowData.resolutionFormDesc) {
            values.iv_resolution = dialogRowData.resolutionFormDesc
            setResolutionDocumentThumbnail(dialogRowData.resolutionFormDesc)
        }
        if (dialogRowData.certFormDesc) {
            values.iv_form29initial = dialogRowData.certFormDesc
            setForm29DocumentThumbnail(dialogRowData.certFormDesc)
        }
        if (dialogRowData.certMemoDesc) {
            values.iv_memo = dialogRowData.certMemoDesc
            setMemorandumDocumentThumbnail(dialogRowData.certMemoDesc)
        }
    }, [dialogRowData])

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                // Required Documents Validation
                iv_applicant_cnic_document_front: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_applicant_cnic_document_back: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_property_documents: Yup.mixed().required('Please upload property documents in jpg, jpeg, png or pdf format.'),
                iv_near_by_bill: Yup.mixed().required('Please upload near by electricity bill in jpg, jpeg, png or pdf format.'),
                iv_any_other_document: Yup.mixed().nullable().notRequired('Please upload any other document in jpg, jpeg, png or pdf format.'),
                iv_owner_cnic_document_front: Yup.mixed().when('applicantStatus', {
                    is: (value) => (applicantStatus === 'Tenant' || applicantStatus === 'tenant'),
                    then: Yup.mixed().required('Please upload cnic front in jpg, jpeg, png or pdf format.'),
                    otherwise: Yup.mixed(),
                }),
                iv_owner_cnic_document_back: Yup.mixed().when('applicantStatus', {
                    is: (value) => (applicantStatus === 'Tenant' || applicantStatus === 'tenant'),
                    then: Yup.mixed().required('Please upload cnic back in jpg, jpeg, png or pdf format.'),
                    otherwise: Yup.mixed(),
                }),
                iv_noc_owner: Yup.mixed().when('applicantStatus', {
                    is: (value) => (applicantStatus === 'Tenant' || applicantStatus === 'tenant'),
                    then: Yup.mixed().required('Please upload NoC in jpg, jpeg, png or pdf format.'),
                    otherwise: Yup.mixed(),
                }),
                iv_resolution: Yup.mixed().when('connectionType', {
                    is: (value) => (connectionType === "Industrial" || connectionType === "industrial"),
                    then: Yup.mixed().required("Please upload resolution form in jpg, jpeg, png or pdf format."),
                    otherwise: Yup.mixed(),
                }),
                iv_memo: Yup.mixed().nullable().notRequired("Please upload MoA Certificate in jpg, jpeg, png or pdf format."),
                iv_form29initial: Yup.mixed().when('connectionType', {
                    is: (value) => (connectionType === "Industrial" || connectionType === "industrial"),
                    then: Yup.mixed().required("Please upload Form 29 in jpg, jpeg, png or pdf format."),
                    otherwise: Yup.mixed(),
                }),
            }),
            onSubmit: async (values, { resetForm }) => {
                setViewBackdrop(true);
                let applicationProgressId = dialogRowData.applicationProgressId;
                if (applicationProgressId == 0) {
                    applicationProgressId += 1
                }
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);

                const formdata = new FormData();
                formdata.append("applicationId", dialogRowData.applicationId);
                formdata.append("applicationProgressId", applicationProgressId);
                formdata.append("objectionStatus", 2);
                formdata.append("remarks", "Documents Reuploaded.");
                formdata.append("ownerNOCFlag", "");
                formdata.append("premisesDocumentFlag", "");
                formdata.append("copyOfApplicantCNICFrontFlag", "");
                formdata.append("copyOfApplicantCNICBackFlag", "");
                formdata.append("scannedCopyOfNearByElectricityBillFlag", "");
                formdata.append("copyOfOwnerCNICFrontFlag", "");
                formdata.append("copyOfOwnerCNICBackFlag", "");
                formdata.append("resolutionFormDescFlag", "");
                formdata.append("certMemoDescFlag", "");
                formdata.append("certFormDescFlag", "");
                formdata.append("premisesDocument", propertyDocumentsThumbnail);
                formdata.append("copyOfApplicantCNICFront", applicantCnicDocumentFrontThumbnail);
                formdata.append("copyOfApplicantCNICBack", applicantCnicDocumentBackThumbnail);
                formdata.append("ownerNOC", nocOwnerDocumentThumbnail);
                formdata.append("copyOfOwnerCNICFront", ownerCnicDocumentFrontThumbnail);
                formdata.append("copyOfOwnerCNICBack", ownerCnicDocumentBackThumbnail);
                formdata.append("scannedCopyOfNearByElectricityBill", nearByBillDocumentThumbnail);
                formdata.append("resolutionFormDesc", resolutionDocumentThumbnail);
                formdata.append("certMemoDesc", memorandumDocumentThumbnail);
                formdata.append("certFormDesc", form29DocumentThumbnail);
                formdata.append("anyOtherDocument", anyOtherDocumentThumbnail);

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: formdata,
                    redirect: "follow"
                };

                await fetch(cfpBaseUrl + "enc/updateENCDocuments", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            navigate('/new-connection-table')
                        }
                        else {
                            setViewBackdrop(false)
                            console.log(result.message);
                        }
                    })
                    .catch(error => {
                        setViewBackdrop(false)
                        console.log(error);
                    });
            }
        })
    //Function to set states of documents


    const ApplicantCnicDocumentFront = (event) => {
        const newFileName = 'copyOfApplicantCNICFront.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setApplicantCnicDocumentFront, setApplicantCnicFrontError, setApplicantCnicDocumentFrontThumbnail, newFileName);
    };

    const ApplicantCnicDocumentBack = (event) => {
        const newFileName = 'copyOfApplicantCNICBack.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setApplicantCnicDocumentBack, setApplicantCnicBackError, setApplicantCnicDocumentBackThumbnail, newFileName);
    };

    const PropertDocuments = (event) => {
        const newFileName = 'copyOfPropertyDocument.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setPropertDocuments, setPropertyDocumentError, setPropertyDocumentsThumbnail, newFileName);
    };

    const NearByBillDocument = (event) => {
        const newFileName = 'scannedCopyOfNearByElectricityBill.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setNearByBillDocument, setNearByBillError, setNearByBillDocumentThumbnail, newFileName);
    };

    const AnyOtherDocument = (event) => {
        const newFileName = 'anyOtherDocument.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setAnyOtherDocument, setAnyOtherDocumentError, setAnyOtherDocumentThumbnail, newFileName);
    };

    const NocOwnerDocument = (event) => {
        const newFileName = 'ownerNOC.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setNocOwnerDocument, setNocError, setNocOwnerDocumentThumbnail, newFileName);
    };

    const OwnerCnicDocumentFront = (event) => {
        const newFileName = 'copyOfOwnerCNIC.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setOwnerCnicDocumentFront, setOwnerCnicFrontError, setOwnerCnicDocumentFrontThumbnail, newFileName);
    };

    const OwnerCnicDocumentBack = (event) => {
        const newFileName = 'copyOfOwnerCNIC.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setOwnerCnicDocumentBack, setOwnerCnicBackError, setOwnerCnicDocumentBackThumbnail, newFileName);
    };

    const ResolutionDocument = (event) => {
        const newFileName = 'resolutionFormDesc.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setResolutionDocument, setBodError, setResolutionDocumentThumbnail, newFileName);
    };

    const MemorandumDocument = (event) => {
        const newFileName = 'certMemoDesc.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setMemorandumDocument, setMemorandumError, setMemorandumDocumentThumbnail, newFileName);
    };

    const Form29Document = (event) => {
        const newFileName = 'certFormDesc.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setForm29Document, setFormError, setForm29DocumentThumbnail, newFileName);
    };

    const errorCloses = () => {
        setError('');
    }


    return (
        <>
            <Grid container className='nC'>
                <Box className='nCContainer'>
                    <Typography variant='h6' className='heading'>
                        New Connection Document Update Form
                    </Typography>
                    <Box className="progressBarBackground">
                        <Box className="progressBarContainer">
                            <Box className="pbDocGroup">
                                <Typography className="badge">
                                    {
                                        (dialogRowData.copyOfApplicantCNICFront && dialogRowData.copyOfApplicantCNICBack) || (applicantCnicDocumentFront && applicantCnicDocumentBack)
                                            ?
                                            <Box className='backgroundAttached'>
                                                <DoneIcon className='icon' />
                                            </Box> :
                                            <p className='backgroundUnAttached'>1</p>
                                    }
                                </Typography>
                                <Typography className='badgeText'>Applicant's CNIC.</Typography>
                            </Box>
                            <Box className="pbDocGroup">
                                <Typography className="badge">
                                    {
                                        dialogRowData.premisesDocument || propertyDocuments
                                            ?
                                            <Box className='backgroundAttached'>
                                                <DoneIcon className='icon' />
                                            </Box> :
                                            <p className='backgroundUnAttached'>2</p>
                                    }
                                </Typography>
                                <Typography className='badgeText'>Property Documents</Typography>
                            </Box>
                            <Box className="pbDocGroup">
                                <Typography className="badge">
                                    {
                                        dialogRowData.scannedCopyOfNearByElectricityBill || nearByBillDocument
                                            ? <Box className='backgroundAttached'>
                                                <DoneIcon className='icon' />
                                            </Box> :
                                            <p className='backgroundUnAttached'>3</p>
                                    }
                                </Typography>
                                <Typography className='badgeText'>Near-by Electricity Bill</Typography>
                            </Box>
                            <Box className="pbDocGroup">
                                <Typography className="badge">
                                    {
                                        dialogRowData.scannedCopyOfNearByElectricityBill || nearByBillDocument
                                            ? <Box className='backgroundAttached'>
                                                <DoneIcon className='icon' />
                                            </Box> :
                                            <p className='backgroundUnAttached'>4</p>
                                    }
                                </Typography>
                                <Typography className='badgeText'>Any Other Document</Typography>
                            </Box>

                            {
                                (
                                    dialogRowData.applicantStatus === 'Tenant' || dialogRowData.applicantStatus === 'tenant') &&
                                <>
                                    <Box className="pbDocGroup">
                                        <Typography className="badge">
                                            {
                                                (dialogRowData.copyOfOwnerCNICFront && dialogRowData.copyOfOwnerCNICBack) || (ownerCnicDocumentFront && ownerCnicDocumentBack)
                                                    ? <Box className='backgroundAttached'>
                                                        <DoneIcon className='icon' />
                                                    </Box> :
                                                    <p className='backgroundUnAttached'>5</p>
                                            }
                                        </Typography>
                                        <Typography className='badgeText'>Owner's CNIC.</Typography>
                                    </Box>
                                    <Box className="pbDocGroup">
                                        <Typography className="badge">
                                            {
                                                dialogRowData.ownerNOC || nocOwnerDocument
                                                    ? <Box className='backgroundAttached'>
                                                        <DoneIcon className='icon' />
                                                    </Box> :
                                                    <p className='backgroundUnAttached'>6</p>
                                            }</Typography>
                                        <Typography className='badgeText'>Noc from Owner</Typography>
                                    </Box>
                                </>
                            }
                            {
                                (dialogRowData.connectionType === 'Industrial')
                                    ?
                                    <>
                                        <Box className="pbDocGroup">
                                            <Typography className="badge">
                                                {
                                                    dialogRowData.resolutionFormDesc || resolutionDocument
                                                        ?
                                                        <Box className='backgroundAttached'>
                                                            <DoneIcon className='icon' />
                                                        </Box> :
                                                        <p className='backgroundUnAttached'>
                                                            {values.iv_applicant_status === 'Owner' ? '5' : '7'}
                                                        </p>
                                                }
                                            </Typography>
                                            <Typography className='badgeText'> BoD's Resolution Form</Typography>
                                        </Box>
                                        <Box className="pbDocGroup">
                                            <Typography className="badge">
                                                {
                                                    dialogRowData.certMemoDesc || memorandumDocument
                                                        ?
                                                        <Box className='backgroundAttached'>
                                                            <DoneIcon className='icon' />
                                                        </Box> :
                                                        <p className='backgroundUnAttached'>
                                                            {values.iv_applicant_status === 'Owner' ? '6' : '8'}
                                                        </p>}
                                            </Typography>
                                            <Typography className='badgeText'>Memorandum</Typography>
                                        </Box>
                                        <Box className="pbDocGroup">
                                            <Typography className="badge">
                                                {
                                                    dialogRowData.certFormDesc || form29Document
                                                        ? <Box className='backgroundAttached'>
                                                            <DoneIcon className='icon' />
                                                        </Box> :
                                                        <p className='backgroundUnAttached'>
                                                            {values.iv_applicant_status === 'Owner' ? '7' : '9'}
                                                        </p>}
                                            </Typography>
                                            <Typography className='badgeText'>Form-29</Typography>
                                        </Box>
                                    </> : null}
                        </Box>
                    </Box>
                    <form className='ncform'>
                        <Typography variant="h6" className='groupTitle' >
                            Application Details
                        </Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <Typography className='fieldLabel' > Application Id</Typography>
                                <TextField
                                    required
                                    type='text'
                                    name="iv_applied_load"
                                    value={dialogRowData.applicationId}
                                    disabled
                                    id="iv_applied_load"
                                    className='textInputField'
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className='fieldLabel' >  Connection Type</Typography>
                                <TextField
                                    autoWidth={false}
                                    value={dialogRowData.connectionType}
                                    disabled
                                    className='textInputField'
                                    name="iv_connection_type"
                                    id="iv_connection_type"
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <Typography className='fieldLabel' >Applicant Status</Typography>
                                <TextField
                                    type='double'
                                    name="iv_near_by_reference_no"
                                    value={dialogRowData.applicantStatus}
                                    disabled
                                    id="iv_near_by_reference_no"
                                    className='textInputField'
                                />
                            </Grid>
                        </Grid>
                        <Typography variant="h6" className='groupTitle'>
                            Documents
                        </Typography>
                        <Grid container spacing={1} className='documentsContainer' >
                            <Grid item lg='2' >
                                <Typography className='documentLabel' >1- Applicant's CNIC.</Typography>
                                <Box className='documentError'>{((errors.iv_applicant_cnic_document_front && touched.iv_applicant_cnic_document_front) || (errors.iv_applicant_cnic_document_back && touched.iv_applicant_cnic_document_back)) ? (errors.iv_applicant_cnic_document_front) : null}</Box>
                            </Grid>
                            <Grid item lg='1'>
                                {
                                    dialogRowData.copyOfApplicantCNICFront ?
                                        <Grid container>
                                            <Grid item sm={6}>
                                                <img src={applicantCnicDocumentFrontThumbnail} style={{ width: '50%' }} />
                                            </Grid>
                                            {
                                                (!dialogRowData.copyOfApplicantCNICFrontFlag || dialogRowData.copyOfApplicantCNICFrontFlag === -1) &&
                                                <Grid item sm={6}>
                                                    <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                        Change
                                                        <input hidden accept={documentExtensions} id='iv_applicant_cnic_document_front' name='iv_applicant_cnic_document_front' type="file" onChange={ApplicantCnicDocumentFront} />
                                                    </Button>
                                                    <Box className="documentError">
                                                        {
                                                            applicantCnicFrontError
                                                        }
                                                    </Box>
                                                </Grid>
                                            }
                                        </Grid>
                                        :
                                        applicantCnicDocumentFront ?
                                            <>
                                                <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicDocumentFront('') }} />}  >
                                                    {applicantCnicDocumentFrontThumbnail && <img src={applicantCnicDocumentFrontThumbnail} alt="Applicant CNIC" width="50" />}
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        applicantCnicFrontError
                                                    }
                                                </Box>
                                            </>
                                            :
                                            <>
                                                <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} >
                                                    Front
                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_document_front' name='iv_applicant_cnic_document_front' type="file" onChange={ApplicantCnicDocumentFront} />
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        applicantCnicFrontError
                                                    }
                                                </Box>
                                            </>
                                }
                            </Grid>
                            <Grid item lg='1'>
                                {
                                    dialogRowData.copyOfApplicantCNICBack ?
                                        <Grid container>
                                            <Grid item sm={6}>
                                                <img src={applicantCnicDocumentBackThumbnail} style={{ width: '50%' }} />
                                            </Grid>
                                            {
                                                (!dialogRowData.copyOfApplicantCNICBackFlag || dialogRowData.copyOfApplicantCNICBackFlag === -1) &&
                                                <Grid item sm={6}>
                                                    <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                        Change
                                                        <input hidden accept={documentExtensions} id='iv_applicant_cnic_document_back' name='iv_applicant_cnic_document_back' type="file" onChange={ApplicantCnicDocumentBack} />
                                                    </Button>
                                                    <Box className="documentError">
                                                        {
                                                            applicantCnicBackError
                                                        }
                                                    </Box>
                                                </Grid>
                                            }
                                        </Grid>
                                        :
                                        applicantCnicDocumentBack ?
                                            <>
                                                <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicDocumentBack('') }} />}  >
                                                    {applicantCnicDocumentBackThumbnail && <img src={applicantCnicDocumentBackThumbnail} alt="Applicant CNIC Back" width="50" />}
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        applicantCnicBackError
                                                    }
                                                </Box>
                                            </>
                                            :
                                            <>
                                                <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                    Back
                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_document_back' name='iv_applicant_cnic_document_back' type="file" onChange={ApplicantCnicDocumentBack} />
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        applicantCnicBackError
                                                    }
                                                </Box>
                                            </>
                                }
                            </Grid>
                            <Grid item lg='2' >
                                <Typography className='documentLabel' >2- Property Documents</Typography>
                                <Box className='documentError'>{errors.iv_property_documents && touched.iv_property_documents ? (errors.iv_property_documents) : null}</Box>
                            </Grid>
                            <Grid item lg='2'>
                                {
                                    dialogRowData.premisesDocument ?
                                        <Grid container>
                                            <Grid item sm={6}>
                                                <img src={propertyDocumentsThumbnail} style={{ width: '50%' }} />
                                            </Grid>
                                            {
                                                (!dialogRowData.premisesDocumentFlag || dialogRowData.premisesDocumentFlag === -1) &&
                                                <Grid item sm={6}>
                                                    <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                        Change
                                                        <input hidden accept={documentExtensions} id='iv_property_documents' name='iv_property_documents' type="file" onChange={PropertDocuments} />
                                                    </Button>
                                                    <Box className="documentError">
                                                        {
                                                            propertyDocumentError
                                                        }
                                                    </Box>
                                                </Grid>
                                            }
                                        </Grid>
                                        :
                                        propertyDocuments ?
                                            <>
                                                <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setPropertDocuments('') }} />}  >
                                                    {propertyDocumentsThumbnail && <img src={propertyDocumentsThumbnail} alt="Applicant CNIC" width="100" />}
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        propertyDocumentError
                                                    }
                                                </Box>
                                            </>
                                            :
                                            <>
                                                <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                    Upload
                                                    <input hidden accept={documentExtensions} id='iv_property_documents' name='iv_property_documents' type="file" onChange={PropertDocuments} />
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        propertyDocumentError
                                                    }
                                                </Box>
                                            </>
                                }
                            </Grid>
                            <Grid item lg='2' >
                                <Typography className='documentLabel' >3- Near-by electricity bill 
                                     {/* <span style={{ color: "#A1A1A1", marginLeft: '3%' }}>(Optional)</span> */}
                                </Typography>
                                <Box className='documentError'>{errors.iv_near_by_bill && touched.iv_near_by_bill ? (errors.iv_near_by_bill) : null}</Box>
                            </Grid>
                            <Grid item lg='2'>
                                {
                                    dialogRowData.scannedCopyOfNearByElectricityBill ?
                                        <Grid container>
                                            <Grid item sm={6}>
                                                <img src={nearByBillDocumentThumbnail} style={{ width: '50%' }} />
                                            </Grid>
                                            {
                                                (!dialogRowData.scannedCopyOfNearByElectricityBillFlag || dialogRowData.scannedCopyOfNearByElectricityBillFlag === -1) &&
                                                <Grid item sm={6}>
                                                    <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                        Change
                                                        <input hidden accept={documentExtensions} id='iv_near_by_bill' name='iv_near_by_bill' type="file" onChange={NearByBillDocument} />
                                                    </Button>
                                                    <Box className="documentError">
                                                        {
                                                            nearByBillError
                                                        }
                                                    </Box>
                                                </Grid>
                                            }
                                        </Grid>
                                        :
                                        nearByBillDocument ?
                                            <>
                                                <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setNearByBillDocument('') }} />}  >
                                                    {nearByBillDocumentThumbnail && <img src={nearByBillDocumentThumbnail} alt="Applicant CNIC" width="100" />}
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        nearByBillError
                                                    }
                                                </Box>
                                            </>
                                            :
                                            <>
                                                <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                    Upload
                                                    <input hidden accept={documentExtensions} id='iv_near_by_bill' name='iv_near_by_bill' type="file" onChange={NearByBillDocument} />
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        nearByBillError
                                                    }
                                                </Box>
                                            </>
                                }
                            </Grid>
                            <Grid item lg='2' >
                                <Typography className='documentLabel' >4- Any Other Document  <span style={{ color: "#A1A1A1", marginLeft: '3%' }}>(Optional)</span></Typography>
                                <Box className='documentError'>{errors.iv_any_other_document && touched.iv_any_other_document ? (errors.iv_any_other_document) : null}</Box>
                            </Grid>
                            <Grid item lg='2'>
                                {
                                    dialogRowData.anyOtherDocument ?
                                        <Grid container>
                                            <Grid item sm={6}>
                                                <img src={anyOtherDocumentThumbnail} style={{ width: '50%' }} />
                                            </Grid>
                                            {
                                                (!dialogRowData.anyOtherDocumentFlag || dialogRowData.anyOtherDocumentFlag === -1) &&
                                                <Grid item sm={6}>
                                                    <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                        Change
                                                        <input hidden accept={documentExtensions} id='iv_any_other_document' name='iv_any_other_document' type="file" onChange={AnyOtherDocument} />
                                                    </Button>
                                                    <Box className="documentError">
                                                        {
                                                            anyOtherDocumentError
                                                        }
                                                    </Box>
                                                </Grid>
                                            }
                                        </Grid>
                                        :
                                        anyOtherDocument ?
                                            <>
                                                <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setAnyOtherDocument('') }} />}  >
                                                    {anyOtherDocumentThumbnail && <img src={anyOtherDocumentThumbnail} alt="Any Other Document" width="100" />}
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        anyOtherDocumentError
                                                    }
                                                </Box>
                                            </>
                                            :
                                            <>
                                                <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} className='btn'>
                                                    Upload
                                                    <input hidden accept={documentExtensions} id='iv_any_other_document' name='iv_any_other_document' type="file" onChange={AnyOtherDocument} />
                                                </Button>
                                                <Box className="documentError">
                                                    {
                                                        anyOtherDocumentError
                                                    }
                                                </Box>
                                            </>
                                }
                            </Grid>
                            {(dialogRowData.applicantStatus === 'Tenant' || dialogRowData.applicantStatus === 'tenant') &&
                                <>
                                    <Grid item lg='2' >
                                        <Typography className='documentLabel' >5- Owner's CNIC.</Typography>
                                        <Box className='documentError'>{((errors.iv_owner_cnic_document_front && touched.iv_owner_cnic_document_front) || (errors.iv_owner_cnic_document_back && touched.iv_owner_cnic_document_back)) ? (errors.iv_owner_cnic_document_front) : null}</Box>
                                    </Grid>
                                    <Grid item lg='1'>
                                        {
                                            dialogRowData.copyOfOwnerCNICFront ?
                                                <Grid container>
                                                    <Grid item sm={6}>
                                                        <img src={ownerCnicDocumentFrontThumbnail} style={{ width: '50%' }} />
                                                    </Grid>
                                                    {
                                                        (!dialogRowData.copyOfOwnerCNICFrontFlag || dialogRowData.copyOfOwnerCNICFrontFlag === -1) &&
                                                        <Grid item sm={6}>
                                                            <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                                Change
                                                                <input hidden accept={documentExtensions} id='iv_owner_cnic_document_front' name='iv_owner_cnic_document_front' type="file" onChange={OwnerCnicDocumentFront} />
                                                            </Button>
                                                            <Box className="documentError">
                                                                {
                                                                    ownerCnicFrontError
                                                                }
                                                            </Box>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                :
                                                ownerCnicDocumentFront ?
                                                    <>
                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setOwnerCnicDocumentFront('') }} />}  >
                                                            {ownerCnicDocumentFrontThumbnail && <img src={ownerCnicDocumentFrontThumbnail} alt="Owner CNIC Front" width="50" />}
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                ownerCnicFrontError
                                                            }
                                                        </Box>
                                                    </>
                                                    :
                                                    <>
                                                        <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} className='btn' >
                                                            Upload
                                                            <input hidden accept={documentExtensions} id='iv_owner_cnic_document_front' name='iv_owner_cnic_document_front' type="file" onChange={OwnerCnicDocumentFront} />
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                ownerCnicFrontError
                                                            }
                                                        </Box>
                                                    </>
                                        }
                                    </Grid>
                                    <Grid item lg='1'>
                                        {
                                            dialogRowData.copyOfOwnerCNICBack ?
                                                <Grid container>
                                                    <Grid item sm={6}>
                                                        <img src={ownerCnicDocumentBackThumbnail} style={{ width: '50%' }} />
                                                    </Grid>
                                                    {
                                                        (!dialogRowData.copyOfOwnerCNICBackFlag || dialogRowData.copyOfOwnerCNICBackFlag === -1) &&
                                                        <Grid item sm={6}>
                                                            <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                                Change
                                                                <input hidden accept={documentExtensions} id='iv_owner_cnic_document_back' name='iv_owner_cnic_document_back' type="file" onChange={OwnerCnicDocumentBack} />
                                                            </Button>
                                                            <Box className="documentError">
                                                                {
                                                                    ownerCnicBackError
                                                                }
                                                            </Box>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                :
                                                ownerCnicDocumentBack ?
                                                    <>
                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setOwnerCnicDocumentBack('') }} />}  >
                                                            {ownerCnicDocumentBackThumbnail && <img src={ownerCnicDocumentBackThumbnail} alt="Owner CNIC Back" width="50" />}
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                ownerCnicBackError
                                                            }
                                                        </Box>
                                                    </>
                                                    :
                                                    <>
                                                        <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} className='btn' >
                                                            Back
                                                            <input hidden accept={documentExtensions} id='iv_owner_cnic_document_back' name='iv_owner_cnic_document_back' type="file" onChange={OwnerCnicDocumentBack} />
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                ownerCnicBackError
                                                            }
                                                        </Box>
                                                    </>
                                        }
                                    </Grid>
                                    <Grid item lg='2' >
                                        <Typography className='documentLabel' >6- NOC. from owner </Typography>
                                        <Box className='documentError'>{errors.iv_noc_owner && touched.iv_noc_owner ? (errors.iv_noc_owner) : null}</Box>
                                    </Grid>
                                    <Grid item lg='2'>
                                        {
                                            dialogRowData.ownerNOC ?
                                                <Grid container>
                                                    <Grid item sm={6}>
                                                        <img src={nocOwnerDocumentThumbnail} style={{ width: '50%' }} />
                                                    </Grid>
                                                    {
                                                        (!dialogRowData.ownerNOCFlag || dialogRowData.ownerNOCFlag === -1) &&
                                                        <Grid item sm={6}>
                                                            <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                                Change
                                                                <input hidden accept={documentExtensions} id='iv_noc_owner' name='iv_noc_owner' type="file" onChange={NocOwnerDocument} />
                                                            </Button>
                                                            <Box className="documentError">
                                                                {
                                                                    nocError
                                                                }
                                                            </Box>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                :
                                                nocOwnerDocument ?
                                                    <>
                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setNocOwnerDocument('') }} />}  >
                                                            {nocOwnerDocumentThumbnail && <img src={nocOwnerDocumentThumbnail} alt="Owner Noc" width="100" />}
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                nocError
                                                            }
                                                        </Box>
                                                    </>
                                                    :
                                                    <>
                                                        <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} className='btn' >
                                                            Upload
                                                            <input hidden accept={documentExtensions} id='iv_noc_owner' name='iv_noc_owner' type="file" onChange={NocOwnerDocument} />
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                nocError
                                                            }
                                                        </Box>
                                                    </>
                                        }
                                    </Grid>
                                </>
                            }
                            {(dialogRowData.connectionType === "Industrial")
                                ? <>
                                    <Grid item lg='2' >
                                        <Typography className='documentLabel'>
                                            {dialogRowData.applicantStatus === 'Owner' || dialogRowData.applicantStatus === 'owner' ?
                                                '5- ' :
                                                '7- '
                                            }
                                            Resolution from BoD's in the favour of <span style={{ marginLeft: '6%' }}>sigantory</span>
                                        </Typography>
                                        <Box className='documentError'>  {errors.iv_resolution && touched.iv_resolution ? (errors.iv_resolution) : null}</Box>
                                    </Grid>
                                    <Grid item lg='2'>
                                        {
                                            dialogRowData.resolutionFormDesc ?
                                                <Grid container>
                                                    <Grid item sm={6}>
                                                        <img src={resolutionDocumentThumbnail} style={{ width: '50%' }} />
                                                    </Grid>
                                                    {
                                                        (!dialogRowData.resolutionFormDescFlag || dialogRowData.resolutionFormDescFlag === -1) &&
                                                        <Grid item sm={6}>
                                                            <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                                Change
                                                                <input hidden accept={documentExtensions} id='iv_resolution' name='iv_resolution' type="file" onChange={ResolutionDocument} />
                                                            </Button>
                                                            <Box className="documentError">
                                                                {
                                                                    bodError
                                                                }
                                                            </Box>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                :
                                                resolutionDocument ?
                                                    <>
                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setResolutionDocument('') }} />}  >
                                                            {resolutionDocumentThumbnail && <img src={resolutionDocumentThumbnail} alt="Resolution Document" width="100" />}
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                bodError
                                                            }
                                                        </Box>
                                                    </>
                                                    :
                                                    <>
                                                        <Button variant='outlined' component="label" startIcon={<FileUploadOutlinedIcon />} className='btn' >
                                                            Upload
                                                            <input hidden accept={documentExtensions} id='iv_resolution' name='iv_resolution' type="file" onChange={ResolutionDocument} />
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                bodError
                                                            }
                                                        </Box>
                                                    </>
                                        }
                                    </Grid>
                                    <Grid item lg='2' >
                                        <Typography className='documentLabel'>
                                            {dialogRowData.applicantStatus === 'Owner' || dialogRowData.applicantStatus === 'owner' ?
                                                '6- ' :
                                                '8- '
                                            }
                                            Memorandum of association certificate <span style={{ color: "#A1A1A1", marginLeft: '6%' }}>(Optional)</span>
                                        </Typography>
                                        <Box className='documentError'>  {errors.iv_memo && touched.iv_memo ? (errors.iv_memo) : null}</Box>
                                    </Grid>
                                    <Grid item lg='2'>
                                        {
                                            dialogRowData.certMemoDesc ?
                                                <Grid container>
                                                    <Grid item sm={6}>
                                                        <img src={memorandumDocumentThumbnail} style={{ width: '50%' }} />
                                                    </Grid>
                                                    {
                                                        (!dialogRowData.certMemoDescFlag || dialogRowData.certMemoDescFlag === -1) &&
                                                        <Grid item sm={6}>
                                                            <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                                Change
                                                                <input hidden accept={documentExtensions} id='iv_memo' name='iv_memo' type="file" onChange={MemorandumDocument} />
                                                            </Button>
                                                            <Box className="documentError">
                                                                {
                                                                    memorandumError
                                                                }
                                                            </Box>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                :
                                                memorandumDocument ?
                                                    <>
                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setMemorandumDocument('') }} />}  >
                                                            {memorandumDocumentThumbnail && <img src={memorandumDocumentThumbnail} alt="Memorandum Document" width="100" />}
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                memorandumError
                                                            }
                                                        </Box>
                                                    </>
                                                    :
                                                    <>
                                                        <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn' >
                                                            Upload
                                                            <input hidden accept={documentExtensions} id='iv_memo' name='iv_memo' type="file" onChange={MemorandumDocument} />
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                memorandumError
                                                            }
                                                        </Box>
                                                    </>
                                        }
                                    </Grid>
                                    <Grid item lg='2' >
                                        <Typography className='documentLabel'>
                                            {dialogRowData.applicantStatus === 'Owner' || dialogRowData.applicantStatus === 'owner' ?
                                                '7- ' :
                                                '9- '
                                            }
                                            Certified true copy of form-29
                                        </Typography>
                                        <Box className='documentError'>  {errors.iv_form29initial && touched.iv_form29initial ? (errors.iv_form29initial) : null}</Box>
                                    </Grid>
                                    <Grid item lg='4'>
                                        {
                                            dialogRowData.certFormDesc ?
                                                <Grid container>
                                                    <Grid item sm={6}>
                                                        <img src={form29DocumentThumbnail} style={{ width: '50%' }} />
                                                    </Grid>
                                                    {
                                                        (!dialogRowData.certFormDescFlag || dialogRowData.certFormDescFlag === -1) &&

                                                        <Grid item sm={6}>
                                                            <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                                Change
                                                                <input hidden accept={documentExtensions} id='iv_form29initial' name='iv_form29initial' type="file" onChange={Form29Document} />
                                                            </Button>
                                                            <Box className="documentError">
                                                                {
                                                                    formError
                                                                }
                                                            </Box>
                                                        </Grid>
                                                    }
                                                </Grid>
                                                :
                                                form29Document ?
                                                    <>
                                                        <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setForm29Document('') }} />}  >
                                                            {form29DocumentThumbnail && <img src={form29DocumentThumbnail} alt="Form 29 Document" width="100" />}
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                formError
                                                            }
                                                        </Box>
                                                    </>
                                                    :
                                                    <>
                                                        <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn' >
                                                            Upload
                                                            <input hidden accept={documentExtensions} id='iv_form29initial' name='iv_form29initial' type="file" onChange={Form29Document} />
                                                        </Button>
                                                        <Box className="documentError">
                                                            {
                                                                formError
                                                            }
                                                        </Box>
                                                    </>
                                        }
                                    </Grid>
                                </> :
                                null
                            }
                        </Grid>
                        {
                            error &&
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        }
                        <Box sx={{ marginTop: '18%', textAlign: 'right' }}>
                            <Button sx={{ width: '10%', marginLeft: '1%', marginBottom: '1%' }} variant='contained' component="label" type='submit' onClick={handleSubmit} >
                                Submit
                            </Button>
                        </Box>
                    </form >
                </Box >
            </Grid >

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default Newconnectionupdatedocuments
